export default __webpack_public_path__ + "static/media/photospreview.ebdcd074.svg";